export default __webpack_public_path__ + "static/ziggy-3e69d95436cdad56e598ee2252ae89ee.webp";